import { ItiString } from "@/iti-core-react/utils/iti-string";

const Utils = {
	formatSize(bytes: number): string {
		if (!bytes) return "0 MB";

		const GB = 1024 * 1024 * 1024;

		if (bytes >= GB) {
			const gbValue = bytes / GB;
			return `${Number(gbValue).toFixed(2)} GB`;
		}

		const MB = 1024 * 1024;
		const KB = 1024;

		if (bytes >= MB) {
			return `${(bytes / MB).toFixed(2)} MB`;
		}
		if (bytes >= KB) {
			return `${(bytes / KB).toFixed(2)} KB`;
		}

		return `${bytes} B`;
	},

	formatTotalSize(bytes: number): string {
		if (!bytes) return "0 MB";

		const GB = 1024 * 1024 * 1024;

		if (bytes >= GB) {
			const gbValue = bytes / GB;
			return `${Math.ceil(gbValue)} GB`;
		}

		return Utils.formatSize(bytes);
	},

	formatDate(createTime: any, showTime = false): string {
		const date = new Date(createTime);
		const day = date.getDate().toString().padStart(2, "0");
		const month = (date.getMonth() + 1).toString().padStart(2, "0");
		const year = date.getFullYear();
		let formattedDate = `${day}/${month}/${year}`;

		if (showTime) {
			const hours = date.getHours().toString().padStart(2, "0");
			const minutes = date.getMinutes().toString().padStart(2, "0");
			formattedDate += ` ${hours}:${minutes}`;
		}

		return formattedDate;
	},

	parseToKB(size: number, fixedPoint = 2, showUnit = false) {
		return `${(size / 1e3)
			.toFixed(3)
			.split(".")[0]
			.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${
			(size / 1e3).toFixed(fixedPoint).split(".")[1]
		}${showUnit ? " KB" : ""}`;
	},

	parseToMB(size: number, fixedPoint = 2, showUnit = false) {
		return `${(size / 1e6)
			.toFixed(6)
			.split(".")[0]
			.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${
			(size / 1e6).toFixed(fixedPoint).split(".")[1]
		}${showUnit ? " MB" : ""}`;
	},

	parseToGB(size: number, fixedPoint = 2, showUnit = false) {
		return `${(size / 1e9)
			.toFixed(9)
			.split(".")[0]
			.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${
			(size / 1e9).toFixed(fixedPoint).split(".")[1]
		}${showUnit ? " GB" : ""}`;
	},

	hasValue(value: any) {
		return value !== undefined && value !== null;
	},

	getFileName(file: string) {
		const idx = file.lastIndexOf(".");
		if (idx !== -1) {
			return file.substring(0, idx);
		}
		return file;
	},

	getExtensionName(file: string) {
		const idx = file.lastIndexOf(".");
		if (idx !== -1) {
			return file.substring(idx + 1);
		}
		return ItiString.Empty;
	},

	replaceCharInJsonProperties(
		json: any,
		oldChar: string,
		newChar: string,
	): any {
		if (typeof json !== "object" || json === null) {
			return json;
		}

		if (Array.isArray(json)) {
			return json.map((item) =>
				Utils.replaceCharInJsonProperties(item, oldChar, newChar),
			);
		}

		const result: any = {};
		for (const key of Object.keys(json)) {
			result[key.replace(oldChar, newChar)] = Utils.replaceCharInJsonProperties(
				json[key],
				oldChar,
				newChar,
			);
		}

		return result;
	},

	roundSeconds(input: string): string {
		// Expresión regular para encontrar la parte de la hora en la cadena
		const timeRegex = /\b(\d{2}:\d{2}):(\d{2})\.\d+\b/;

		// Utiliza la expresión regular para encontrar la hora y los segundos
		const match = input.match(timeRegex);
		if (match) {
			const hoursMinutes = match[1]; // Captura HH:MM
			let seconds = Number.parseInt(match[2], 10); // Captura SS

			// Redondear los segundos
			seconds = Math.round(seconds);

			// Asegúrate de que los segundos sean siempre de dos dígitos
			const roundedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

			// Reconstruye la hora con los segundos redondeados
			const roundedTime = `${hoursMinutes}:${roundedSeconds}`;

			// Reemplaza la hora original con la hora redondeada en la cadena
			return input.replace(timeRegex, roundedTime);
		}

		// Si no se encuentra la hora, devuelve la cadena original
		return input;
	},

	clearSessionExperimentParams: () => {
		sessionStorage.removeItem("deploymentId"); // Limpiar el deploymentId de session storage
		sessionStorage.removeItem("deploymentStatus"); // Limpiar el deploymentStatus de session storage
		sessionStorage.removeItem("experimentId"); // Limpiar el experimentId de session storage
	},
};

export default Utils;
